/**
 * Session Engine v3 — EXPLORATORY / non-Canon prototype.
 *
 * Reads exclusivity relationships from the real item-relationship store
 * (authored on the item detail page) and derives the prototype's read-only
 * exclusivity groups for the current pool. The session never authors
 * relationships — it only surfaces them in scenario planning.
 */

import { useEffect, useMemo } from 'react';
import { useItemRelationshipsStore } from '../../stores/prioritization/itemRelationshipsStore';
import { deriveExclusivityGroups } from './engineLogic';
import type { ExclusivityGroup } from './types';

export function useDerivedExclusivity(poolItemIds: string[]): ExclusivityGroup[] {
  const groups = useItemRelationshipsStore((s) => s.groups);
  const memberships = useItemRelationshipsStore((s) => s.groupMemberships);
  const fetchFromSupabase = useItemRelationshipsStore((s) => s.fetchFromSupabase);

  useEffect(() => {
    if (groups.length === 0) void fetchFromSupabase().catch(() => {});
  }, [groups.length, fetchFromSupabase]);

  const key = poolItemIds.join(',');
  return useMemo(
    () => deriveExclusivityGroups(groups, memberships, poolItemIds),
    // poolItemIds identity changes each render; key captures its contents.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [groups, memberships, key],
  );
}
